module.exports = __webpack_public_path__ + "img/paytm1.b6407b9f.png";